import Dialog from 'components/formComponents/Base/Dialog';
import { CYPRESS_DATA } from './constants';

type Props = {
  isOpen: boolean;
  title: string;
  description: string;
  acceptLabel: string;
  cancelLabel: string;
  onAccept: () => void;
  onCancel: () => void;
};

const ImportReplaceDialog = ({
  isOpen,
  title,
  description,
  acceptLabel,
  cancelLabel,
  onAccept,
  onCancel,
}: Props) => (
  <Dialog
    isOpen={isOpen}
    title={title}
    description={description}
    acceptLabel={acceptLabel}
    cancelLabel={cancelLabel}
    onAccept={onAccept}
    onCancel={onCancel}
    dataCy={CYPRESS_DATA.importReplaceDialog}
  />
);

export default ImportReplaceDialog;
